import React from 'react';
import Select from 'react-select';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#0f172a', // slate-900
        borderColor: state.isFocused ? '#3b82f6' : '#475569', // blue-500 or slate-600
        color: '#e2e8f0', // slate-200
        minHeight: '38px',
        boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
        '&:hover': {
            borderColor: '#64748b' // slate-500
        }
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#1e293b', // slate-800
        border: '1px solid #475569', // slate-600
        zIndex: 9999
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#334155' : state.isFocused ? '#475569' : 'transparent', // slate-700 / slate-600
        color: '#e2e8f0', // slate-200
        cursor: 'pointer',
        '&:active': {
            backgroundColor: '#475569'
        }
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#e2e8f0' // slate-200
    }),
    input: (provided) => ({
        ...provided,
        color: '#e2e8f0' // slate-200
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#94a3b8' // slate-400
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: '#475569' // slate-600
    })
};

export function SearchableSelect({ options, value, onChange, placeholder, isDisabled, className, isClearable = true }) {
    // Determine the currently selected object based on value string/number
    const selectedOption = options.find(opt => opt.value === value) || null;

    const handleChange = (selected) => {
        // Pass a synthetic event-like object to maintain compatibility with standard onChange handlers
        if (onChange) {
            onChange({ target: { value: selected ? selected.value : '' } });
        }
    };

    return (
        <div className={`text-sm ${className || ''}`}>
            <Select
                styles={customStyles}
                options={options}
                value={selectedOption}
                onChange={handleChange}
                placeholder={placeholder || 'Select...'}
                isDisabled={isDisabled}
                isClearable={isClearable}
                isSearchable
            />
        </div>
    );
}
